<div class="setting-panel">
  <cc-tag-group
    [isWorking]="isWorking"
    [tagGroups]="projectTagGroups"
    [title]="projectTagTitle"
    [readonly]="true"
  >
  </cc-tag-group>
  <cc-tag-group
    class="team-tag-container"
    [isWorking]="isWorking"
    [tagGroups]="tagGroups"
    (remove)="onRemove($event)"
    (add)="onAdd()"
    (edit)="onEdit($event)"
    [title]="teamTagTitle"
  >
  </cc-tag-group>
</div>
